var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.is_signed != true)?_c('v-row',{staticClass:"my-2"},[_c('v-col',{attrs:{"cols":"12"}},[_c('InitiativeSignIn')],1)],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }